import { departmentsMenuSX } from '@/components/content/Header/styles/departmentsMenu';
import { Menu } from '@mui/material';
import { type TransitionProps } from '@mui/material/transitions';
import { FC, ReactElement, ReactNode, type ComponentType } from 'react';

interface DepartmentsMenuProps {
	children: ReactNode;
	name: string;
	open: boolean;
	anchorEl: HTMLElement | null;
	handleClose: () => void;
	Transition?: ComponentType<TransitionProps & { children: ReactElement }>;
}

export const DepartmentsMenu: FC<DepartmentsMenuProps> = ({
	children,
	name,
	open,
	anchorEl,
	handleClose,
	Transition,
}) => (
	<Menu
		id={name}
		anchorEl={anchorEl}
		keepMounted
		open={open}
		onClose={handleClose}
		TransitionComponent={Transition}
		TransitionProps={{
			timeout: 500,
			style: {
				transitionTimingFunction: 'ease-in',
			},
			onEnter: (node: HTMLElement) => {
				node.style.transitionTimingFunction = 'ease-in';
			},
			onExit: (node: HTMLElement) => {
				node.style.transitionTimingFunction = 'ease-out';
			},
		}}
		sx={departmentsMenuSX}
		elevation={6}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'left',
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'left',
		}}
		slotProps={{
			paper: {
				sx: {
					borderRadius: 0,
				},
			},
		}}
	>
		{children}
	</Menu>
);
